// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1xuxw","selects":"Documents_selects__2L5jf"};